import { Checkbox } from "antd";
import { fmtDate, fmtDateTimeFull } from "./utils";

export const tableRenderDate = (value) => <div>{fmtDate(value)}</div>
export const tableRenderDateTime = (value) => <div>{fmtDateTimeFull(value)}</div>
export const tableRenderCheckbox = value => <Checkbox checked={value} />